import { rgba } from 'polished';
import {
  sideNavBaseStyle,
  TSideNavTheme,
} from '../../base/customComponents/sideNav';

import { TStyleConfig } from '../../base/types';
import navInnerBg from '@/assets/junglebet/images/backgrounds/clothTexture.png';

export const SideNav: TStyleConfig<TSideNavTheme> = {
  baseStyle: (props) => {
    const base = sideNavBaseStyle(props);

    return {
      ...base,
      readableColor: 'white',
      borderBottom: 'white',
      bottomBorderRadius: base.borderBottomRadius,
      background: {
        bg: `linear-gradient(180deg, var(--bc-colors-delta-100), var(--bc-colors-delta-200)), url(${navInnerBg})`,
        backgroundBlendMode: 'overlay',
        boxShadow: 'lg',
        borderRadius: [null, null, null, 'md'],
        alignSelf: [null, null, null, 'flex-start'],
        overflow: 'hidden',
        w: 'auto',
        m: [null, null, null, '5px 0px'],
        mb: [null, null, null, '9px'],
      },
      drawer: {
        ...base.drawer,
      },
      drawerBody: {
        '> div, a': {
          '> .dropDownInner, a[class*="dropDownInner"]': {
            _first: {
              borderColor: 'transparent',
              cursor: 'initial',
            },
            '&:hover, &:active': {
              bg: rgba(`${props.theme.colors.beta[500]}`, 0.8),
            },
          },
        },
      },
      icon: {
        ...base.icon,
        boxSize: '5',
        color: 'white',
        fill: 'white',
      },
      headerSX: {
        cursor: 'default',
        textTransform: 'capitalize',
        '&:hover': {
          borderBottomColor: 'blackAlpha.400',
          bg: 'transparent',
        },
      },
      dropDownInner: {
        ...base.dropDownInner,
        color: 'white',
        px: '4',
      },
      linkSX: {
        ...base.linkSX,
      },
      link: {
        ...base.link,

        fontSize: 'md',
        fontWeight: 'normal',
        fontStyle: 'normal',
        height: ['55px', '45px'],
        color: 'delta.500',
        textShadow: [
          'unset',
          null,
          null,
          '0px 2px 0px rgba(255, 255, 255, 0.25)',
        ],
        transition: 'all, 0.2s linear',
        borderLeftWidth: '3px',
        borderLeftColor: 'transparent',
        fontFamily: 'CarterOne',
        textTransform: 'capitalize',

        borderBottom: ['1px solid', null, null, '1px dashed'],
        borderBottomColor: [
          'rgba(101, 41, 0, 0.25)',
          null,
          null,
          'blackAlpha.400',
        ],
        ':last-child': {
          borderBottom: ['1px solid', null, null, 'none'],
          borderBottomColor: ['rgba(101, 41, 0, 0.25)', null, null, 'unset'],
        },
        p: ['1', null, null, '2'],
        ml: '0',
        '~ .nested': {
          pl: '10',
        },

        ':hover, :active': {
          bg: 'blackAlpha.400',
        },

        '.icon, .svgIcon': {
          transition: 'all, 0.2s linear',
          color: 'delta.500',
          fill: 'delta.500',
          path: {
            transition: 'all, 0.2s linear',
          },
        },

        '.dropDownIcon': {
          fill: 'none',
        },
      },

      dropDownContainerClosed: {
        '.dropDownInner': {
          pl: '2',
          borderBottom: ['1px solid', null, null, '1px dashed'],
          borderBottomColor: [
            'rgba(101, 41, 0, 0.25)',
            null,
            null,
            'blackAlpha.400',
          ],
        },

        '> a, .dropDownIcon, a': {
          color: 'delta.500',
        },

        '&:hover, &:active': {
          '&.chakra-icon': {
            color: 'delta.50',
          },

          // @NB - Delete styling in here to remove 'dancing' top events btn
          '.dropDownInner': {},

          '.svgIcon, .icon': {
            color: 'delta.50',
          },
        },
      },
      dropDownContainerOpen: {
        h: 'unset',
        p: '0',
        color: 'delta.50',
        bg: 'delta.400',
        boxShadow: '0px 1px 7px 2px #321100 inset',

        _hover: {
          '.dropDownInner': {
            bg: 'blackAlpha.300',
          },
        },

        '.dropDownInner': {
          color: 'delta.50',
          '.chakra-icon, .icon': {
            color: 'delta.50',
            svg: {
              fill: 'delta.50',
            },
          },
        },

        '> a, .dropDownIcon, a': {
          color: 'delta.50',
          svg: {
            fill: 'delta.50',
          },
        },

        '.svgIcon, .icon': {
          color: 'delta.50',
          fill: 'delta.50',
        },
      },
    };
  },
  sizes: {},
  variants: {},
};
